import React from 'react';
import NumberFormat from 'react-number-format';
import './styles.css';
import {Spring} from 'react-spring/renderprops';
import BasicControlGroup from '../../../../components/BasicControlGroup';
import Collapsable from '../../../../components/Collapsable';
import LinkButton from '../../../../components/LinkButton';
import PanelContainer from '../../../../components/PanelContainer';
import {ANIMATION_TIMEOUT_INOUT} from '../../../../constants/animation';
import LinkBuilder from '../../../../helpers/link-builder';
import FollowUpEmailTemplateAssignedProcessesDialog from '../../../Dialog/components/FollowUpEmailTemplateAssignedProcessesDialog';

const EmailTemplateFollowupItem = (props) => {
  const {
    onDelete,
    data: { EmailTemplateFollowupID, Name, Subject, Message, Processes },
  } = props;

  const handleViewProcesses = () => {
    FollowUpEmailTemplateAssignedProcessesDialog({
      id: EmailTemplateFollowupID,
    });
  };

  const handleDelete = () => {
    onDelete &&
      typeof onDelete === 'function' &&
      onDelete(EmailTemplateFollowupID, Processes);
  };

  return (
    <Spring
      from={{ opacity: 0 }}
      to={{ opacity: 1 }}
      config={{ duration: ANIMATION_TIMEOUT_INOUT }}
    >
      {(props) => (
        <PanelContainer
          styles={(props, { paddingTop: '25px', marginBottom: '10px' })}
        >
          <div className="email-template-item-followup">
            <div className="email-template-item-followup__controls">
              <BasicControlGroup>
                <LinkButton
                  text="Edit"
                  to={LinkBuilder.getEmailTemplateFollowupLink(
                    EmailTemplateFollowupID
                  )}
                />
                {Number(Processes) > 0 && (
                  <LinkButton
                    text="Assigned To"
                    controlFunc={handleViewProcesses}
                  />
                )}
                <LinkButton text="Delete" controlFunc={handleDelete} />
              </BasicControlGroup>
            </div>

            <div className="email-template-item-followup__content">
              <div className="email-template-item-followup__highlights">
                <div className="email-template-item-followup__highlight">
                  <div className="email-template-item-followup__block">
                    <div className="email-template-item-followup__name">
                      Processes
                    </div>
                    <div className="email-template-item-followup__value">
                      {
                        <NumberFormat
                          thousandSeparator
                          value={Processes}
                          displayType={'text'}
                        />
                      }
                    </div>
                  </div>
                </div>
                <div className="email-template-item-followup__highlight">
                  <div className="email-template-item-followup__block">
                    <div className="email-template-item-followup__name">
                      Name
                    </div>
                    <div className="email-template-item-followup__value">
                      {Name}
                    </div>
                  </div>
                </div>
                <div className="email-template-item-followup__highlight">
                  <div className="email-template-item-followup__block">
                    <div className="email-template-item-followup__name">
                      Subject
                    </div>
                    <div className="email-template-item-followup__value">
                      {Subject}
                    </div>
                  </div>
                </div>
              </div>
              <div className="email-template-item-followup__content">
                <Collapsable
                  btnHidden={
                    Message.length < 400 &&
                    Message.split(/\r\n|\r|\n/).length <= 5
                  }
                  maskHidden={
                    Message.length < 400 &&
                    Message.split(/\r\n|\r|\n/).length <= 5
                  }
                >
                  <div dangerouslySetInnerHTML={{ __html: Message }} />
                </Collapsable>
              </div>
            </div>
          </div>
        </PanelContainer>
      )}
    </Spring>
  );
};

export default EmailTemplateFollowupItem;
